import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {SessionQuery} from '../../_shared/modules/agri-auth/state/session';
import {Observable} from 'rxjs';
import {User} from '../../_shared/modules/agri-auth/models/user.model';

@Component({
  selector: 'app-work-container',
  templateUrl: './work-container.component.html',
  styleUrls: ['./work-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkContainerComponent implements OnInit {

  user$: Observable<User> = this.sessionQuery.user$;

  showPowerBiModal: boolean;

  constructor(private sessionQuery: SessionQuery) { }

  ngOnInit() {
  }

}
